import {
  Typography,
  Box,
  TextField,
  Radio,
  Paper,
  Link,
  IconButton,
  Alert,
  Snackbar,
} from "@mui/material";
import React, { useState, useContext, useEffect } from "react";
import CommonAccordion from "../../custom-components/CommonAccordion";
import { ReactComponent as GenerateButtonIcon } from "../../../images/generateButton.svg";
import yaml from "js-yaml";
import { ReactComponent as UserStoryIcon } from "../../../images/userStoryIcon.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as DeleteIcon } from "../../../images/APIDeleteIcon.svg";
import { LoadingModalContext } from "../../main-pages/ServicePage";
import { pojoClasstWithToolCalling, xmlPojoclassWithToolCalling } from "../../../services/webServices";
import { apiStepDefinitionToolCalling } from "../../../services/webServices";
import MessagePopup from "../../popup-components/MessagePopup";

function IntroduceSCHEMA({setSchemaType, schemaType, setFileContentJson, setFileContentXml, confirmed, introduceSchemaNextButton, IntroduceSchema,pojoClasses, stepDefinitionData,framework, featurefileData, pojoclass}) {
  // console.log("props of intro schema", IntroduceSchema);
  const location = useLocation();
  const { setLoadingState } = useContext(LoadingModalContext);
  const navigate = useNavigate();
  const nextButton = !!introduceSchemaNextButton ? [introduceSchemaNextButton] : [];
  //const [schemaType, setSchemaType] = useState(props.schemaType); // Default to JSON
  const [schemaContent, setSchemaContent] = useState("");
  const [uploadedFile, setUploadedFile] = useState(null);
//  const [fileContentJson, setFileContentJson] = useState(null);
 // const [fileContentXml, setFileContentXml] = useState(null);
  const [getUrl, setGetUrl] = useState("");
  const [error, setError] = useState("");
  const [pojoDataJson, setPojoDataJson] = useState(null);
  const [pojoDataXml, setPojoDataXml] = useState(null);
 // const [pojoClasses, setPojoClasses] = useState(null);
  const [pojoData, setPojoData] = useState({});
 // const [stepDefinitionData, setStepDefinitionData] = useState([]);

  const [showError, setShowError] = useState(false);
    const [popupOpen, setPopupOpen] = useState(false);
    const [popupMessage, setPopupMessage] = useState("");
  // console.log("props of intro schema", props);
  
  const defaultLocatorsExpanded =
  (confirmed === true && pojoClasses === null && stepDefinitionData.length === 0) || (IntroduceSchema === true && pojoClasses === null && stepDefinitionData.length === 0)
    ;

  useEffect(() => {
    // console.log(pojoClasses,"pojoClassespojoClasses");
    // console.log("Schma type", schemaType)
    
  });

  const handleSchemaTypeChange = (event) => {
    const newType = event.target.value;
    setSchemaType(newType);

    if (newType === "None" || uploadedFile) {
      const fileExtension = uploadedFile?.name.split(".").pop().toLowerCase();
      const isValidExtension =
        newType === "JSON"
          ? fileExtension === "json"
          : newType === "XML"
            ? fileExtension === "xml"
            : false;

      if (newType === "None" || !isValidExtension) {
        setUploadedFile(null);
        setFileContentJson(null);
        setFileContentXml(null);
      }
    }
  };

  const handleSchemaContentChange = (event) => {
    setSchemaContent(event.target.value);
  };

  const handleGetUrlChange = (e) => {
    setGetUrl(e.target.value);
  };

  // const handleGeneratePOJO = async () => {
  //   let fake;
  //   const startProgress = (setProgress) => {
  //     let progress = 0;
  //     let stop = false;
  //     let finalMessageShown = false;

  //     const interval = setInterval(() => {
  //       if (stop) return;

  //       progress += 2.2;
  //       if (progress >= 98 && !finalMessageShown) {
  //         finalMessageShown = true;
  //         setLoadingState((prev) => ({
  //           ...prev,
  //           message: "Almost done! Fetching your output",
  //         }));
  //       }

  //       if (progress >= 98) progress = 98;

  //       setProgress((prev) => ({
  //         ...prev,
  //         progress: Math.max(prev.progress, Math.floor(progress)),
  //       }));
  //     }, 200);

  //     return {
  //       stop: () => {
  //         stop = true;
  //         clearInterval(interval);
  //       },
  //       completeTo100: async () => {
  //         stop = true;
  //         clearInterval(interval);

  //         // Rush to 100%
  //         setProgress((prev) => ({
  //           ...prev,
  //           progress: 100,
  //         }));
  //         await new Promise((res) => setTimeout(res, 500));
  //       },
  //     };
  //   };

  //   const finishTo100AndClose = async () => {
  //     await fake.completeTo100();
  //     setLoadingState({ open: false, message: "", progress: null });
  //   };
  //   // Initial message
  //   setLoadingState({
  //     open: true,
  //     message: "Generating Pojo Classes",
  //     progress: 0,
  //   });

  //   fake = startProgress(setLoadingState);
  //   try {
  //     if (schemaType === "JSON") {
  //       const responsejson = await pojoClasstWithToolCalling(
  //         fileContentJson,
  //         props.framework
  //       );
  //       setPojoDataJson(responsejson.data);
  //       setPojoClasses(responsejson.data);
  //       console.log("Parsed JSON:", responsejson);
  //       await finishTo100AndClose();
  //       navigate(`/dashboard/api-testing/${props.framework}/${props.projectType}`, {
  //         state: {
  //           ...location.state,
  //           pojoData: responsejson.data,
  //           stepDefinitionData: "",
  //           // confirmed: false
  //         },
  //         replace: true,
  //       });
  //     } else if (schemaType === "XML") {
  //       const responsexml = await xmlPojoclassWithToolCalling(fileContentXml, props.framework);
  //       setPojoDataXml(responsexml.data);
  //       setPojoClasses(responsexml.data);
  //       console.log("Parsed XML:", responsexml.data);
  //       navigate(`/dashboard/api-testing/${props.framework}/${props.projectType}`, {
  //         state: {
  //           ...location.state,
  //           pojoData: responsexml.data,
  //           stepDefinitionData: "",
  //           // confirmed : false
  //         },
  //         replace: true,
  //       });
  //     }
  //   } catch (error) {
  //     console.error("Error generating POJO classes:", error);
  //     setLoadingState({ open: false, message: "", progress: null });
  //   } finally {
  //     setLoadingState({ open: false, message: "", progress: null });
  //   }
  // };

  // const handleGenerateStepDefinition = async () => {

  //   setPojoClasses("")
  //   console.log("props.featureFileData", props.featureFileData);
  //   let fake;
  //   const startProgress = (setProgress) => {
  //     let progress = 0;
  //     let stop = false;
  //     let finalMessageShown = false;

  //     const interval = setInterval(() => {
  //       if (stop) return;

  //       progress += 1.5;
  //       if (progress >= 98 && !finalMessageShown) {
  //         finalMessageShown = true;
  //         setLoadingState((prev) => ({
  //           ...prev,
  //           message: "Almost done! Fetching your output",
  //         }));
  //       }

  //       if (progress >= 98) progress = 98;

  //       setProgress((prev) => ({
  //         ...prev,
  //         progress: Math.max(prev.progress, Math.floor(progress)),
  //       }));
  //     }, 200);

  //     return {
  //       stop: () => {
  //         stop = true;
  //         clearInterval(interval);
  //       },
  //       completeTo100: async () => {
  //         stop = true;
  //         clearInterval(interval);

  //         // Rush to 100%
  //         setProgress((prev) => ({
  //           ...prev,
  //           progress: 100,
  //         }));
  //         await new Promise((res) => setTimeout(res, 500));
  //       },
  //     };
  //   };

  //   const finishTo100AndClose = async () => {
  //     await fake.completeTo100();
  //     setLoadingState({ open: false, message: "", progress: null });
  //   };
  //   // Initial message
  //   setLoadingState({
  //     open: true,
  //     message: "Generating Step Definition",
  //     progress: 0,
  //   });

  //   fake = startProgress(setLoadingState);
  //   try {
  //     const response = await apiStepDefinitionToolCalling({
  //       featureFileGenerated: props.featureFileData,

  //     }, props.framework);
  //     console.log(response, "response");
  //     console.log(response.data, "response.dat");
  //     setStepDefinitionData(response.data);
  //     await finishTo100AndClose();

  //     navigate(`/dashboard/api-testing/${props.framework}/${props.projectType}`, {
  //       state: { ...location.state, stepDefinitionData: response.data, pojoData: "", },
  //     });

  //   } catch (error) {
  //     console.error("Error generating step definition:", error);
  //     setLoadingState({ open: false, message: "", progress: null });
  //   } finally {
  //     setLoadingState({ open: false, message: "", progress: null });
  //   }
  // };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const fileExtension = file.name.split(".").pop().toLowerCase();
      if (schemaType === "JSON" && fileExtension !== "json") {
        setError(
          "Please upload a .json file when JSON schema type is selected"
        );
        setShowError(true);
        setPopupMessage("Please upload a .json file when JSON schema type is selected");
        setPopupOpen(true);
        return;
      } else if (schemaType === "XML" && fileExtension !== "xml") {
        setError("Please upload a .xml file when XML schema type is selected");
        setShowError(true);
        setPopupMessage("Please upload a .xml file when XML schema type is selected");
        setPopupOpen(true);
        
        return;
      }

      setUploadedFile(file);
      const reader = new FileReader();

      reader.onload = (event) => {
        if (schemaType === "JSON") {
          const parsedContent = JSON.parse(event.target.result);
          console.log("Parsed JSON:", parsedContent);
          setFileContentJson(parsedContent);
        } else if (schemaType === "XML") {
          const parser = new DOMParser();
          const xmlDoc = parser.parseFromString(
            event.target.result,
            "text/xml"
          );
          const serializer = new XMLSerializer();
          const xmlString = serializer.serializeToString(xmlDoc);
          console.log(xmlString);

          setFileContentXml({ schema: xmlString });
        }
      };
      reader.readAsText(file);
    }
  };

  const handleFileRemove = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setUploadedFile(null);
    setFileContentJson(null);
    setFileContentXml(null);
    setSchemaContent("");
  };

  const handleResetForm = () => {
    setUploadedFile(null);
    setFileContentJson(null);
    setFileContentXml(null);
    setSchemaContent("");
    setGetUrl("");
  };

  const handleCloseError = () => {
    setShowError(false);
  };

  const getAcceptAttribute = () => {
    return schemaType === "JSON" ? ".json" : ".xml";
  };

  const accordionDetails = (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ display: "flex", marginBottom: 2, gap: 1 }}>
        <Box
          component="label"
          sx={{
            borderRadius: "8px",
            padding: "6px 14px",
            width: "150%",
            maxWidth: "141px",
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            //cursor: (schemaType === "XML" || schemaType === "None") && (pojoClasses !== null || stepDefinitionData.length > 0) ? "not-allowed" : "pointer",
            border:
              schemaType === "JSON" ? "2px solid #49A3FF" : "1px solid #ccc",
          }}
        >
          <Radio
            checked={schemaType === "JSON"}
            onChange={handleSchemaTypeChange}
            value="JSON"
            name="schema-type"
            //  disabled={(schemaType === "XML" || schemaType === "None") && (pojoClasses !== null || stepDefinitionData.length > 0) }

            sx={{
              padding: "0 6px 0 0",
              transform: "scale(0.8)",
              "& .MuiSvgIcon-root": {
                fontSize: "22px",
              },
              "&.Mui-checked": {
                color: "#64b5f6",
              },
            }}
          />
          <Typography sx={{ fontSize: "15px" }}>JSON</Typography>
        </Box>
        <Box
          component="label"
          sx={{
            borderRadius: "8px",
            padding: "6px 12px",
            width: "150%",
            maxWidth: "141px",
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            border:
              schemaType === "XML" ? "2px solid #49A3FF" : "1px solid #ccc",
          }}
        >
          <Radio
            checked={schemaType === "XML"}
            onChange={handleSchemaTypeChange}
            value="XML"
            name="schema-type"
            // disabled={(schemaType === "JSON" || schemaType === "None") && (pojoClasses !== null ||stepDefinitionData.length > 0) }
            sx={{
              padding: "0 8px 0 0",
              transform: "scale(0.8)",
              "& .MuiSvgIcon-root": {
                fontSize: "22px",
              },
              "&.Mui-checked": {
                color: "#64b5f6",
              },
            }}
          />
          <Typography sx={{ fontSize: "15px" }}>XML</Typography>
        </Box>
        <Box
          component="label"
          sx={{
            borderRadius: "8px",
            padding: "6px 12px",
            width: "150%",
            maxWidth: "141px",
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            border:
              schemaType === "None" ? "2px solid #49A3FF" : "1px solid #ccc",
          }}
        >
          <Radio
            checked={schemaType === "None"}
            onChange={handleSchemaTypeChange}
            value="None"
            name="schema-type"
            // disabled={(schemaType === "JSON" || schemaType === "XML") && (pojoClasses !== null ) }

            sx={{
              padding: "0 8px 0 0",
              transform: "scale(0.8)",
              "& .MuiSvgIcon-root": {
                fontSize: "22px",
              },
              "&.Mui-checked": {
                color: "#64b5f6",
              },
            }}
          />
          <Typography sx={{ fontSize: "15px" }}>None</Typography>
        </Box>
      </Box>

      {schemaType !== "None" && (
        <>
          {!uploadedFile ? (
            <label htmlFor="file-Upload">
              <input
                id="file-Upload"
                type="file"
                accept={getAcceptAttribute()}
                style={{ display: "none" }}
                onChange={handleFileUpload}
              />
              <Paper
                variant="outlined"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  p: 3,
                  border: "2px dashed #B3D6FF",
                  borderRadius: 2,
                  bgcolor: "#49A3FF0F",
                  mb: 3,
                  cursor: "pointer",
                  width: "100%",
                   boxSizing: "border-box",

                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, }}>
                  <UserStoryIcon sx={{ fontSize: 30, color: "#757575" }} />
                  <Box>
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      Import Document
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      {schemaType === "JSON" ? ".json file" : ".xml file"}
                    </Typography>
                  </Box>
                </Box>
              </Paper>
            </label>
          ) : (
            <Paper
              variant="outlined"
              sx={{
                display: "flex",
                alignItems: "center",
                p: 3,
                width: "85%",
                border: "2px dashed #B3D6FF",
                borderRadius: 2,
                bgcolor: "#49A3FF0F",
                mb: 3,
                width: "100%",
                   boxSizing: "border-box",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  width: "100%",
                }}
              >
                <UserStoryIcon sx={{ fontSize: 30, color: "#757575" }} />
                <Typography noWrap sx={{ flexGrow: 1, maxWidth: "200px" }}>
                  {uploadedFile.name}
                </Typography>
                <Box sx={{ display: "flex", ml: "auto" }}>
                  <Box sx={{ mr: 2 }}>
                    <label htmlFor="file-Upload">
                      <input
                        id="file-Upload"
                        type="file"
                        accept={getAcceptAttribute()}
                        style={{ display: "none" }}
                        onChange={handleFileUpload}
                      />
                      <Link
                        component="button"
                        variant="body2"
                        sx={{ color: "#0094FB", textDecoration: "none" }}
                        onClick={() =>
                          document.getElementById("file-Upload").click()
                        }
                      >
                        Change
                      </Link>
                    </label>
                  </Box>
                  <IconButton onClick={handleFileRemove} size="small">
                    <DeleteIcon color="error" />
                  </IconButton>
                </Box>
              </Box>
            </Paper>
          )}
        </>
      )}

      {schemaType === "None" && (
        <Paper
          variant="outlined"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            p: 3,
            border: "2px dashed #ccc",
            borderRadius: 2,
            bgcolor: "#f5f5f5",
            mb: 3,
            //width: "85%",
            opacity: 0.6,
            width: "100%",
             boxSizing: "border-box",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <UserStoryIcon sx={{ fontSize: 30, color: "#757575" }} />
            <Box>
              <Typography variant="body1" sx={{ mt: 1, color: "#757575" }}>
                Import Document 
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Select JSON or XML to enable import
              </Typography>
            </Box>
          </Box>
        </Paper>

      )}
      <Typography type="subtitle2" fontSize={14} sx={{ color: "grey", mb: 1 }}> Ensure the uploaded file follows the correct payload schema format.</Typography>

      <Snackbar
        open={showError}
        autoHideDuration={6000}
        onClose={handleCloseError}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseError}
          severity="error"
          sx={{ width: "100%" }}
        >
          {error}
        </Alert>
      </Snackbar>

    </Box>

  );

  // const getButtons = () => {
  //   if (schemaType === "None") {
  //     return [
  //       {
  //         label: "Generate Step Definition",
  //         onClick: handleGenerateStepDefinition,
  //         variant: "contained",
  //         startIcon: <GenerateButtonIcon />,
  //         sx: { textTransform: "none", float: "right" },
  //         disabled: false,
  //       },
  //     ];
  //   } else {
  //     return [
  //       {
  //         label: "Generate POJO Classes",
  //         onClick: handleGeneratePOJO,
  //         variant: "contained",
  //         startIcon: <GenerateButtonIcon />,
  //         sx: { textTransform: "none", float: "right" },
  //         disabled: !uploadedFile,
  //       },
  //     ];
  //   }
  // };

  return (
    <Box>
    <CommonAccordion
      summary="Introduce Schema"
      details={accordionDetails}
      defaultExpanded={defaultLocatorsExpanded}
      buttons={[
        ...nextButton
      ]}
    />
     <MessagePopup
            modalOpen={popupOpen}
            message={popupMessage}
            okayHandler={() => setPopupOpen(false)}
          />
    </Box>
  );
}

export default IntroduceSCHEMA;
